import React, { useRef, useState, useEffect } from 'react'
import SignaturePad from 'react-signature-pad-wrapper';
import Button from '../button/Button';
import { BUTTON_VARIANTS } from '../button/Constants';
import useBase64Image from '../../../containers/SettingsTab/MyAccountCard/Tabs/PrintConfiguration/useS3Image';
import cx from 'classnames'
function SignaturePadWrapper({ onSave, onClear, disabled = false, defaultSignature = null,clearButton=true,viewProfile=false }) {
    const signaturePad = useRef(null);
    const getBase64 = useBase64Image();

    const [isSignatureEmpty, setIsSignatureEmpty] = useState(true);
    const [lastSignatureData, setLastSignatureData] = useState(null);
    
    useEffect(() => {
            if (defaultSignature) {
                const getBase64Data = async (url) => {
                    const base64Data = await getBase64(url);
                    if (base64Data !== null) {
                        signaturePad.current.fromDataURL(base64Data);
                        if(viewProfile) {
                        signaturePad.current.off()
                        }
                    }
                };
                getBase64Data(defaultSignature);
            }
    }, [defaultSignature]);

    // Check if signature pad is empty and auto-save when signature changes
    const checkSignatureEmpty = () => {
        if (signaturePad.current) {
            const isEmpty = signaturePad.current.isEmpty();
            const wasEmpty = isSignatureEmpty;
            
            setIsSignatureEmpty(isEmpty);
            
            // Auto-save when signature changes from empty to not empty, or when signature content changes
            if (!isEmpty && wasEmpty) {
                // Signature was just drawn
                autoSaveSignature();
            } else if (!isEmpty && !wasEmpty) {
                // Check if signature content has changed
                const currentSignatureData = signaturePad.current.toDataURL();
                if (currentSignatureData !== lastSignatureData) {
                    setLastSignatureData(currentSignatureData);
                    autoSaveSignature();
                }
            }
        }
    };

    // Auto-save signature function
    const autoSaveSignature = () => {
        if (signaturePad.current && !signaturePad.current.isEmpty()) {
            const signatureData = signaturePad.current.toDataURL();
            setLastSignatureData(signatureData);
            
            // Call the onSave callback with signature data
            if (onSave) {
                onSave(signatureData);
            }
        }
    };

    // Check signature status periodically
    useEffect(() => {
        const interval = setInterval(checkSignatureEmpty, 100);
        return () => clearInterval(interval);
    }, [isSignatureEmpty, lastSignatureData]);

    const handleClear = () => {
        if (signaturePad.current) {
            signaturePad.current.clear();
            setIsSignatureEmpty(true);
            setLastSignatureData(null);
        }
        // Call the onClear callback if provided
        if (onClear) {
            onClear();
        }
    };
    return (
        <div>
            <div className={cx({
                'border border-met-primary rounded-[5px] bg-blue-50':clearButton,
                'px-8 w-[400px] h-[180px]  border-2 rounded-[5] pb-3 scale-[0.6]':!clearButton
            })}>
                <SignaturePad
                    ref={signaturePad || null}
                    canvasProps={{ className: 'signature-pad' }}
                    disabled={disabled}
                />
            </div>
            {!clearButton&&<div className='font-bold text-lg ml-[132px]'>Doctor Signature</div>}
            {clearButton &&  <div className='flex gap-2 pt-2'>
                <Button 
                    variant={BUTTON_VARIANTS.OUTLINED} 
                    onClickCb={handleClear}
                    disabled={disabled}
                >
                    Clear
                </Button>
            </div>}
        </div>
    )
}

export default SignaturePadWrapper
